module.exports = __webpack_public_path__ + "static/img/xi_11.608f565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_11.png
// module id = Gxto
// module chunks = 1